import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { AppDispatch, RootState } from "../../../core/data/redux/store";
import Lottie from "lottie-react";
import Loader from "../../../core/data/img/car_loading.json";

import {
    useSelector,
    useDispatch
} from "react-redux";

import {
    useForm,
    SubmitHandler
} from "react-hook-form";

import { uploadBookingAddressProof, resetBooking, } from "../../../core/data/redux/action";

const UploadAddressProof = ({ booking }: { booking: any }) => {

    interface Attachment {
        file: File;
        name: string;
        label: string;
        type: "selfie" | "upload";
    }
    type FormValues = {
        attachments: any; // correct type
    };

    const dispatch = useDispatch<AppDispatch>();

    const [addressProofFiles, setAddressProofFiles] = useState<Attachment[]>([]);
    const [isMobile] = useState(window.innerWidth <= 767);

    const {systemSettings, user, bookingAddressProofLoading, bookingAddressProofSuccess, bookingAddressProofError } = useSelector(
        (state: RootState) => ({
            user: state.auth.user,
            bookingAddressProofSuccess: state.booking.bookingAddressProofSuccess,
            bookingAddressProofError: state.booking.bookingAddressProofError,
            bookingAddressProofLoading: state.booking.bookingUploadLicenseLoading,
              systemSettings: state.auth.systemSettings,
        })
    );



     const {
        handleSubmit,
        setValue,
        reset,
        watch,
    } = useForm<FormValues>({
        defaultValues: {
            attachments: [],
        },
    });

    const attachments: Attachment[] = watch("attachments") || [];

    const onDropLicense = (acceptedFiles: File[]) => {
        const newAttachments: Attachment[] = acceptedFiles.map((file, index) => {
            const extension = file.name.split('.').pop();

            const fileName = `${user?.first_name}_address_proof_${user?.id}_${booking?.id}_${addressProofFiles.length + index + 1}.${extension}`;

            const renamedFile = new File([file], fileName, {
                type: file.type,
                lastModified: file.lastModified,
            });

            return {
                file: renamedFile,
                name: renamedFile.name,
                label: 'address_proof',
                type: "upload",
            };
        });

        setAddressProofFiles((prevFiles) => [...prevFiles, ...newAttachments]);
        setValue("attachments", [...attachments, ...newAttachments]);
    };

    const { getRootProps: getLicenseRootProps, getInputProps: getLicenseInputProps } = useDropzone({
        onDrop: onDropLicense,
        accept: { "image/*": [".png", ".jpg", ".jpeg"] },
        multiple: true,
    });



    const removeFile = (fileName: string, type: "address_proof") => {
        let updatedFiles = addressProofFiles;

        if (type === "address_proof") {
            updatedFiles = addressProofFiles.filter((file) => file.name !== fileName);
            setAddressProofFiles(updatedFiles);
        }

        const updatedAttachments = [...updatedFiles];
        setValue("attachments", updatedAttachments);
    };


    const onSubmit: SubmitHandler<FormValues> = (data) => {

        const formData = new FormData();

        formData.append('upload_type', booking?.bookingattachments?.find((item: any) => item.type === "address_proof") ? "reupload" : "initial");
        formData.append('booking_id', booking?.id);

        if (data?.attachments && Array.isArray(data.attachments)) {
            data.attachments.forEach((attachment, index) => {
                formData.append(`attachments[${index}][file]`, attachment?.file);
                formData.append(`attachments[${index}][label]`, attachment?.label);
                formData.append(`attachments[${index}][type]`, attachment?.type);
            });
        }

        dispatch(uploadBookingAddressProof(formData));

    };


    useEffect(() => {
        reset();
        setAddressProofFiles([]);

    }, [booking]);


    const closeModal = () => {
        const modalElement = document.getElementById("upload_address_proof");
        const backdrop = document.querySelector(".modal-backdrop");


        if (modalElement && modalElement.style.display !== "none") {
            modalElement.style.display = "none";
            modalElement.classList.remove("show", "modal-open");
        }

        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";

        if (backdrop) {
            backdrop.remove();
        }

    };

    useEffect(() => {

        if (bookingAddressProofSuccess) {
            dispatch(resetBooking());
            closeModal()
            reset();
            setAddressProofFiles([]);
        }

    }, [bookingAddressProofSuccess, bookingAddressProofError]);



    return (
        <>


            <div
                className="modal new-modal fade"
                id="upload_address_proof"
                data-keyboard="false"
                data-backdrop="static"
                tabIndex={-1}
            >
                <div className="modal-dialog modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Upload Address Proof</h4>
                            <button
                                type="button"
                                className="close-btn"
                                data-bs-dismiss="modal"
                            // onClick={() => {
                            //   closeModal();
                            // }}
                            >
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body">


                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="col-12 px-2">
                                    {/* Address proof Upload */}
                                    <div
                                        {...getLicenseRootProps()}
                                        style={{
                                            border: "2px dashed #ccc",
                                            padding: "8px",
                                            cursor: "pointer",
                                            marginBottom: "10px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <input {...getLicenseInputProps()} />
                                        <p className="py-1 mb-0">{isMobile ? "Click to upload your Address proof" : "Drag & drop your Address proof here, or Click to Select"}</p>
                                    </div>
                                    <small style={{ color: '#6c757d', display: 'block', marginTop: '0.25rem' }}>
                                         {systemSettings.accepted_address_proof}
                                    </small>
                                    <ul>
                                        {addressProofFiles?.map((file) => (
                                            <li key={file.name} className="mb-1">
                                                <img src={URL.createObjectURL(file.file)} width={200} height={200} /> <br />
                                                {file.name}{" "}
                                                <span style={{ color: "red", cursor: "pointer" }} onClick={() => removeFile(file.name, "address_proof")}>  <i className="feather icon-x-circle " /></span>

                                            </li>
                                        ))}
                                    </ul>
                                </div>



                                <div className="col-12 px-2">
                                    {bookingAddressProofLoading ?


                                        <div className="d-flex justify-content-center align-items-center">
                                            <Lottie animationData={Loader} loop={true} style={{ width: 100, height: 100 }} />
                                        </div>

                                        :
                                        <button type="submit" className="btn btn-primary me-1 mt-1">  Upload  </button>
                                    }
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>



        </>
    );
};

export default UploadAddressProof;
